import { format } from 'date-fns';

import { DropdownOption } from 'types/dropdown';

import { cities as stateToCities } from '../../admin/components/location-details/cityMapping';

export const getCities = () =>
  Object.values(stateToCities)
    .flat()
    .filter(Boolean)
    .sort((a, b) => a.localeCompare(b));

export const formatTime = (timestamp: string) =>
  format(new Date(timestamp), 'h:mm a');

export const formatDisplayDate = (dateString: string) => {
  const date = new Date(dateString);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  const inputDate = new Date(date);
  inputDate.setHours(0, 0, 0, 0);

  if (inputDate.getTime() === today.getTime()) {
    return 'Today';
  }
  if (inputDate.getTime() === yesterday.getTime()) {
    return 'Yesterday';
  }
  return format(date, 'dd MMMM yyyy');
};

export const formatMobileNumber = (
  mobileNumber: string,
  countryCode: string
) => {
  if (!mobileNumber) return '';
  return (
    (countryCode
      ? `${countryCode.startsWith('+') ? '' : '+'}${countryCode}-`
      : '') + mobileNumber
  );
};

export { default as deriveDarkColor } from '@helpers/color';

export const isAllOptionsSelected = (
  selectedOptions: DropdownOption[],
  options: DropdownOption[]
) => selectedOptions.length === options.length;

export const getTableColumns = <T extends { accessor: string }>(
  columns: T[],
  showActions: boolean
): T[] =>
  showActions
    ? columns
    : columns.filter((column) => column.accessor !== 'actions');
